module.exports = __webpack_public_path__ + "static/media/img6.9f3c901d.jpg";